module.exports = __webpack_public_path__ + "img/3.0b79e9e4.jpg";